import { render } from "./ResourcesResource.vue?vue&type=template&id=2ef8382e&scoped=true"
import script from "./ResourcesResource.vue?vue&type=script&lang=js"
export * from "./ResourcesResource.vue?vue&type=script&lang=js"

import "./ResourcesResource.vue?vue&type=style&index=0&id=2ef8382e&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef8382e"]])

export default __exports__